import React from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Button,
  Container,
  Row,
  Col,
  FormText,
  Input,
} from "reactstrap";
import SelectListComponent from "../../utils/selectList";
import "../index.scss";

const RateModal = ({
  isOpen,
  form = {},
  onChange,
  onClose,
  onSave,
  editingRate,
  componentErrorMessages = {},
  countries = [],
  USDEquivalent = "",
  isSaving = false,
}) => {
  const handleSelectChange = (payload, key, fieldName) => {
    if (typeof onChange === "function") {
      const value = payload
        ? payload[key] || payload.value || payload.label || payload
        : "";

      // normalize to an event-like object expected by parent's handler
      onChange({ target: { name: fieldName, value } });
    }
  };

  const usdRate = Number(form.exchangeRateUsd);
  const showUSDEquivalent =
    form.exchangeRateUsd !== undefined &&
    form.exchangeRateUsd !== null &&
    form.exchangeRateUsd !== "" &&
    !isNaN(usdRate);
  const formattedUSDEq = (usdRate * 20).toLocaleString(undefined, {
    maximumFractionDigits: 2,
  });
  
  

  return (
    <Modal
      isOpen={isOpen}
      toggle={onClose}
      className="exchange-rate-modal"
      size="md"
    >
      <ModalHeader toggle={onClose}>
        {editingRate ? "Update exchange rate" : "Add new exchange rate"}
      </ModalHeader>
      <ModalBody>
        <Container>
          <Row>
            <Col sm="6">
              <FormGroup
                className={
                  "mb-4 " + (componentErrorMessages.country ? "has-danger" : "")
                }
              >
                <Label>Country</Label>

                <SelectListComponent
                  placeholder={"Select country..."}
                  data={countries}
                  valueKey="Name"
                  textField="Name"
                  selectValue={form.country}
                  onValueChange={(payload) =>
                    handleSelectChange(payload, "Name", "country")
                  }
                />

                {componentErrorMessages.country && (
                  <FormText color="danger">
                    {componentErrorMessages.country}
                  </FormText>
                )}
              </FormGroup>
            </Col>

            <Col sm="6">
              <FormGroup
                className={
                  "mb-4 " +
                  (componentErrorMessages.currencyCode ? "has-danger" : "")
                }
              >
                <Label>Currency Code</Label>
                <Input
                  type="text"
                  placeholder="Enter currency code..."
                  value={form.currencyCode || ""}
                  onChange={(e) =>
                    handleSelectChange(e.target.value, null, "currencyCode")
                  }
                  disabled={editingRate} // prevent changing currency code when editing existing rate
                />
                {componentErrorMessages.currencyCode && (
                  <FormText color="danger">
                    {componentErrorMessages.currencyCode}
                  </FormText>
                )}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col sm="6">
              <FormGroup
                className={
                  "mb-4 " +
                  (componentErrorMessages.exchangeRateUsd ? "has-danger" : "")
                }
              >
                <Label>Exchange Rate (USD)</Label>
                <Input
                  type="number"
                  placeholder="Enter exchange rate..."
                  value={form.exchangeRateUsd || ""}
                  onChange={(e) =>
                    handleSelectChange(e.target.value, null, "exchangeRateUsd")
                  }
                  onWheel={(e) => e.preventDefault()}
                />
                {componentErrorMessages.exchangeRateUsd && (
                  <FormText color="danger">
                    {componentErrorMessages.exchangeRateUsd}
                  </FormText>
                )}
                {showUSDEquivalent && (
                  <FormText
                    style={{
                      backgroundColor: "#F3F3F3",
                      color: "#000000",
                      padding: "6px 8px",
                      display: "inline-block",
                      borderRadius: "4px",
                      width: "100%",
                      marginTop: "8px",
                    }}
                  >
                    USD Equivalent of $20 = {formattedUSDEq}
                  </FormText>
                )}
              </FormGroup>
            </Col>

            <Col sm="6">
              <FormGroup
                className={
                  "mb-4 " +
                  (componentErrorMessages.exchangeRateNgn ? "has-danger" : "")
                }
              >
                <Label>Exchange Rate (NGN)</Label>
                <Input
                  type="number"
                  placeholder="Enter exchange rate..."
                  value={form.exchangeRateNgn || ""}
                  onChange={(e) =>
                    handleSelectChange(e.target.value, null, "exchangeRateNgn")
                  }
                  onWheel={(e) => e.preventDefault()}
                />
                {componentErrorMessages.exchangeRateNgn && (
                  <FormText color="danger">
                    {componentErrorMessages.exchangeRateNgn}
                  </FormText>
                )}
              </FormGroup>
            </Col>
          </Row>
        </Container>
      </ModalBody>
      <ModalFooter>
        <Button
          className="btn-avi-primary"
          type="button"
          onClick={onSave}
          disabled={isSaving}
        >
          {isSaving
            ? editingRate
              ? "Updating..."
              : "Saving..."
            : editingRate
            ? "Update exchange rate"
            : "Save exchange rate"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default RateModal;



// WEBPACK FOOTER //
// ./src/views/exchange-rate/AddNewRate/RateModal.js